module.exports = __webpack_public_path__ + "static/media/product-bg-1.f347743f.png";